<script setup lang="ts">
import AlertComponent from "@/components/AlertComponent.vue";
import StyledPolicyEntry from "@/components/StyledPolicyEntry.vue";
import { PolicyObjectMap } from "@/interfaces/PolicyObjectMap";
import { Policy } from "@/modules/groups/interfaces/policy";
import { computed, ref } from "vue";

interface Props {
  policies: PolicyObjectMap;
  show?: boolean;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  show: true,
});
const showingPolicies = ref(false);
const policyList = computed((): Array<Policy | null> => {
  return Object.values(props.policies).filter((policy) => policy != undefined);
});

const showPoliciesHandler = () => {
  showingPolicies.value = true;
};
</script>

<template>
  <div :class="props.class">
    <span
      v-if="!$slots['button']"
      v-tooltip="'Ver políticas del grupo'"
      class="material-symbols-outlined text-[22px] cursor-pointer"
      @click="showingPolicies = true"
    >
      rule
    </span>

    <div v-else @click="showPoliciesHandler">
      <slot name="button" />
    </div>
  </div>

  <AlertComponent :dismiss="true" v-model="showingPolicies" type="info">
    <template #title>
      El grupo seleccionado cuenta con las siguientes políticas aplicadas
    </template>
    <template #body>
      <div class="flex flex-col gap-4">
        <template v-for="policy in policyList">
          <StyledPolicyEntry
            v-if="policy"
            :policy="policy"
            :key="policy.id"
            :type="policy.type"
          />
        </template>
      </div>
    </template>
    <template #closeButton>Entendido</template>
  </AlertComponent>
</template>

<style scoped></style>
